import history from './history';

const LS_BOOK_PROGRESS = 'LS_BOOK_PROGRESS';

const getSavedProgress = (bookSectionId, userId) => {
  if (!bookSectionId || !userId) {
    return null;
  }

  const progressStorageRAW = localStorage.getItem(LS_BOOK_PROGRESS);

  if (!progressStorageRAW) {
    return null;
  }

  const progressStorage = JSON.parse(progressStorageRAW);
  const userProgress = progressStorage[userId];

  if (!userProgress) {
    return null;
  }

  const progress = userProgress[bookSectionId];
  return progress || null;
};

const getBackToLastSection = (isbn, userId) => {
  if (!isbn || !userId) {
    return false;
  }

  const savedProgress = getSavedProgress(isbn, userId);

  if (!savedProgress) {
    return false;
  }

  const { lastSectionURL, id } = savedProgress;

  // history.action === POP is made to avoid an infinite redirect loop whenever a user
  // want to go back after being automatically redirected.
  if (history.location.pathname === lastSectionURL || history.action === 'POP') {
    return false;
  }

  history.push({ pathname: lastSectionURL, state: { id } });

  return true;
};

const saveBookProgress = (isbn, userId, id) => {
  const [, , pathnameId] = history.location.pathname.split('/');
  if (!isbn || !userId || pathnameId !== id) {
    return;
  }

  const progressStorageRAW = localStorage.getItem(LS_BOOK_PROGRESS);
  const progressStorage = progressStorageRAW ? JSON.parse(progressStorageRAW) : {};

  if (!progressStorage[userId]) {
    progressStorage[userId] = {};
  }

  progressStorage[userId][isbn] = { lastSectionURL: history.location.pathname, id };
  localStorage.setItem(LS_BOOK_PROGRESS, JSON.stringify(progressStorage));
};

export default {
  saveBookProgress,
  getBackToLastSection,
};
